import { Box } from '@chakra-ui/react'
import styled from '@emotion/styled'

export const Container = styled(Box)`
  max-width: calc(100% - 40px);
  margin: 0 auto;
  width: calc(100% - 40px);

  @media (min-width: 1400px) {
    max-width: 1320px;
    width: 1320px;
  }
`
